import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { supabase } from '../utils/supabaseClient';

export interface SeedSourceProgram {
  programId: string;
  seedSourceName: string | null;
  active: boolean;
}

interface SeedSourceRow {
  program_id: string | null;
  name: string | null;
  active: boolean | null;
}

export const seedSourceProgramsQueryKey = ['seed-sources', 'program-ids'] as const;

const fetchSeedSourcePrograms = async (): Promise<SeedSourceProgram[]> => {
  const { data, error } = await supabase
    .from('seed_sources')
    .select('program_id,name,active');

  if (error) {
    throw new Error(error.message || 'Unable to load seed sources');
  }

  const rows = (data ?? []) as SeedSourceRow[];

  return rows
    .filter((row) => Boolean(row.program_id) && row.active !== false)
    .map((row) => ({
      programId: row.program_id as string,
      seedSourceName: row.name,
      active: row.active ?? true,
    }));
};

export function useSeedSourcePrograms(): UseQueryResult<SeedSourceProgram[]> {
  return useQuery<SeedSourceProgram[]>({
    queryKey: seedSourceProgramsQueryKey,
    queryFn: fetchSeedSourcePrograms,
    staleTime: 5 * 60 * 1000,
  });
}
